/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import { Popover } from "antd";
import { useDispatch } from "react-redux";
import ChevronIcon from "../../../../../Common/Svgs/ChevronIcon";
import CloseIcon from "../../../../../Common/Svgs/CloseIcon";
import TimeoffCard from "./Common/TimeoffCard";
import { client } from "../../../../../Utils/axiosClient";
import { updateUsers } from "../../../../../Redux/Slices/users.slice";
import { TIME_OFF_STATUS } from "./Common/constants";

const TimeOffRequests = () => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [timeoffs, setTimeoffs] = useState([]);

  const fetchTimeoffs = async () => {
    try {
      const res = await client.get(
        `${process.env.REACT_APP_API_URL}/drivers/all-time-off`,
        { params: { status: TIME_OFF_STATUS.PENDING } },
      );

      const formatted = res?.data?.timeoffs?.map((item) => ({
        id: item.id,
        startDate: item.startDate,
        endDate: item.endDate,
        appliedOn: item.createdAt,
        updatedAt: item.updatedAt,
        notes: item.notes,
        status: item.status,
        name: item.driverName,
        driverId: item.driverId,
        trips: item.trips || [],
        sessions: item.sessions || [],
        tripsCount: item.tripsCount || 0,
        sessionsCount: item.sessionsCount || 0,
        updatedBy: item.updatedBy || "",
      }));

      setTimeoffs(formatted);
    } catch (err) {
      console.log("Error fetching pending timeoffs:", err);
    }
  };

  useEffect(() => {
    if (open) {
      fetchTimeoffs();
    }
  }, [open]);

  const handleReject = async (id) => {
    try {
      await client.put(
        `${process.env.REACT_APP_API_URL}/drivers/reject-timeoff`,
        {
          id,
        },
      );

      fetchTimeoffs();
    } catch (e) {
      console.log("Error rejecting:", e);
    }
  };

  const handleApprove = async (item) => {
    const trips = item.tripsCount || 0;
    const sessions = item.sessionsCount || 0;

    const hasConflict = trips > 0 || sessions > 0;

    if (hasConflict) {
      dispatch(
        updateUsers({
          key: "transferTimeoffModal",
          value: {
            visible: true,
            timeoffId: item.id,
            driverId: item.driverId,
            trips,
            sessions,
          },
        }),
      );

      setOpen(false);
      return;
    }

    try {
      await client.put(
        `${process.env.REACT_APP_API_URL}/drivers/approve-timeoff`,
        {
          id: item.id,
        },
      );

      fetchTimeoffs();
    } catch (e) {
      console.log("Error approving:", e);
    }
  };

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      open={open}
      arrow={false}
      onOpenChange={(state) => setOpen(state)}
      content={
        <div className="bg-[#FCFCFC] w-[460px] rounded-xl p-6 max-h-[600px] overflow-y-scroll">
          <div className="flex items-start justify-between pb-4 border-b border-light-grey">
            <div>
              <p className="font-poppins font-medium text-base leading-[100%]">
                Time-off Requests
              </p>

              <p className="mt-1 font-aileron font-normal text-xs leading-[100%] text-dark-gray">
                {timeoffs.length} Pending requests
              </p>
            </div>

            <div
              role="button"
              className="cursor-pointer"
              onClick={() => setOpen(false)}
            >
              <CloseIcon className="w-6 h-6 stroke-dark-gray" />
            </div>
          </div>

          {timeoffs?.map((item, index) => (
            <div key={item.id} className="mt-4 space-y-4">
              <TimeoffCard
                item={item}
                handleReject={handleReject}
                handleApprove={handleApprove}
                tripsCount={Number(item?.tripsCount)}
                sessionsCount={Number(item?.sessionsCount)}
              />

              {index + 1 !== timeoffs.length && (
                <div className="w-full h-px bg-light-grey mb-4" />
              )}
            </div>
          ))}
        </div>
      }
    >
      <button
        type="button"
        className="px-3 py-[11px] h-10 flex items-center gap-x-3 bg-yellow hover:bg-yellow-dark rounded-md"
      >
        <p className="font-poppins font-medium text-xs text-black capitalize">
          Time-Off Requests {timeoffs.length ? `(${timeoffs.length})` : ""}
        </p>

        <ChevronIcon
          className={`w-4 h-4 transform transition-all duration-[400] stroke-black       
           ${open ? "-rotate-90" : "rotate-90"}`}
        />
      </button>
    </Popover>
  );
};

export default TimeOffRequests;
